module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-bg-3-3d5711c56cd34fe4c4df8361d5b3ce34.png";